import {
    ID_MODAL_FILTER_BUTTON,
    ID_NAME_CANALES_PREMIUM,
    ID_NAME_CARD_CLASSIC,
    ID_NAME_CARD_INFINITE,
    ID_NAME_CARD_LANDSCAPE,
    ID_NAME_CARD_MODAL_EPISODE, ID_NAME_CARD_MONTH,
    ID_NAME_CARD_TOON_CHARACTER,
    ID_NAME_CARD_VERTICAL, ID_NAME_CARD_YEAR, ID_NAME_FIRST_PAYMENT_METHOD,
    ID_NAME_LO_MAS_VISTO,
    ID_NAME_OLD_CARD_EPG_EVENT,
    ID_NAME_OLD_CARD_PORTRAIT, ID_NAME_PAYMENT_METHOD, ID_NAME_PLAN_SELECTOR_ITEM,
    ID_NAME_PLAYER_CONTROL,
    ID_NAME_SEASON_TEMP,
    ID_NAME_SECONDLEVEL,
    ID_NAME_SUPERDESTACADOS,
    ID_NAME_VCARD_OPTIONS,
    ID_NAME_VCARD_OPTIONS_YELLOW,
    ID_PROFILE_AVATAR_IMAGE
  } from "../constants";

export const getValuesWidthAndHeightDefault = (evt: HTMLElement, ribbonHighlight: HTMLElement, target: HTMLElement) => {

    const id = evt.id;
    const { width = 0, height = 0 } = target.getBoundingClientRect();
    let widthElement = width;
    let heightElement = height;

    switch (true) {

        case id.includes(ID_NAME_SUPERDESTACADOS):
        widthElement = width - 5;
        heightElement = height;
        break;
        case id.includes(ID_NAME_SECONDLEVEL):
        widthElement = width + 12;
        heightElement = height + 11;
        break;
        case id.includes(ID_NAME_PLAYER_CONTROL):
        widthElement = width;
        heightElement = height;
        break;
        case id.includes(ID_NAME_LO_MAS_VISTO):
        widthElement = width + 17;
        heightElement = height + 13;
        break;
        case id.includes(ID_MODAL_FILTER_BUTTON):
        widthElement = width + 7;
        heightElement = height + 8;
        break;
        case id.includes(ID_NAME_SEASON_TEMP):
        widthElement = width + 14;
        heightElement = height + 10;
        break;
        case id.includes(ID_NAME_CANALES_PREMIUM):
        widthElement = width + 6;
        heightElement = height + 7;
        break;
        case id.includes(ID_NAME_CARD_VERTICAL):
        widthElement = width + 7;
        heightElement = height + 8;
        break;
        case id.includes(ID_NAME_CARD_CLASSIC):
        widthElement = width + 7;
        heightElement = height + 6;
        break;
        case id.includes(ID_NAME_CARD_INFINITE):
        widthElement = width + 6;
        heightElement = height + 6;
        break;
        case id.includes(ID_NAME_CARD_TOON_CHARACTER):
        widthElement = width + 11;
        heightElement = height + 11;
        break;
        case id.includes(ID_NAME_CARD_LANDSCAPE):
        widthElement = width + 6;
        heightElement = height + 5;
        break;
        case id === ID_NAME_VCARD_OPTIONS_YELLOW:
        widthElement = width + 4;
        heightElement = height + 4;
        break;
        case id.includes(ID_NAME_VCARD_OPTIONS):
        widthElement = width + 4;
        heightElement = height + 4;
        break;
        case id.includes(ID_NAME_OLD_CARD_PORTRAIT):
        widthElement = width + 2;
        heightElement = height + 3
        break;
        case id.includes(ID_NAME_OLD_CARD_EPG_EVENT):
        widthElement = width + 2;
        heightElement = height + 2;
        break;
        case id.includes(ID_NAME_CARD_MODAL_EPISODE):
        widthElement = width + 3;
        heightElement = height + 5;
        break;
        case id.includes(ID_NAME_PLAN_SELECTOR_ITEM):
        widthElement = width - 5;
        heightElement = height - 5;
        break;
        case id.includes(ID_NAME_CARD_MONTH):
        case id.includes(ID_NAME_CARD_YEAR):
        case id.includes(ID_NAME_FIRST_PAYMENT_METHOD):
        case id.includes(ID_NAME_PAYMENT_METHOD):
        widthElement = width + 4;
        heightElement = height + 4
        break;
        default:
        widthElement = width + 8;
        heightElement = height + 4
        break;
    };

    return { widthElement, heightElement };
}
  
export const getExtraValuesDefault = (evt: HTMLElement, direction: string) => {
    const id = evt.id;
    let extraTop = 0;
    let extraLeft = 0;
    let timer = 0;

    switch (true) {

        case id.includes(ID_NAME_SECONDLEVEL):
        extraLeft = 3;
        extraTop = -8;
        break;
        case id.includes(ID_NAME_PLAYER_CONTROL):
        extraLeft = -3;
        extraTop = - 3;
        break;
        case id.includes(ID_NAME_LO_MAS_VISTO):
        extraLeft = -15;
        extraTop = -7;
        break;
        case id.includes(ID_MODAL_FILTER_BUTTON):
        extraLeft = -6;
        extraTop = -6;
        break
        case id.includes(ID_NAME_SEASON_TEMP):
        extraLeft = -10;
        extraTop = -8;
        break;
        case id.includes(ID_NAME_SUPERDESTACADOS):
        extraLeft = -3;
        extraTop = -7;
        break;
        case id.includes(ID_NAME_CANALES_PREMIUM):
        extraLeft = -6;
        extraTop = -6;
        break;
        case id.includes(ID_NAME_CARD_VERTICAL):
        extraLeft = -6;
        extraTop = -6;
        break;
        case id.includes(ID_NAME_CARD_CLASSIC):
        extraTop = -6;
        extraLeft = -6;
        break;
        case id.includes(ID_NAME_CARD_INFINITE):
        extraLeft = -6;
        extraTop = -6;
        break;
        case id.includes(ID_NAME_CARD_TOON_CHARACTER):
        extraLeft = -8;
        extraTop = -8;
        break;
        case id.includes(ID_NAME_CARD_LANDSCAPE):
        extraLeft = -6;
        extraTop = -5;
        break;
        case id === ID_NAME_VCARD_OPTIONS_YELLOW:
        extraLeft = -5;
        extraTop = -5;
        break;
        case id.includes(ID_NAME_VCARD_OPTIONS):
        extraTop = -5;
        extraLeft = -5;
        break;
        case id.includes(ID_PROFILE_AVATAR_IMAGE):
        extraLeft = - 7;
        extraTop = - 4;
        break;
        case id.includes(ID_NAME_OLD_CARD_PORTRAIT):
        extraTop = -1;
        extraLeft = -2;
        break;
        case id.includes(ID_NAME_OLD_CARD_EPG_EVENT):
        extraTop = -1;
        extraLeft = -2;
        break;
        case id.includes(ID_NAME_CARD_MODAL_EPISODE):
        extraTop = -5;
        extraLeft = -5;
        break;
        case id.includes(ID_PROFILE_AVATAR_IMAGE):
        extraLeft = - 7;
        extraTop = - 4;
        break;
        case id.includes(ID_NAME_PLAN_SELECTOR_ITEM):
        extraTop = 0;
        extraLeft = 0;
        break;
        default:
        extraTop = -5;
        extraLeft = -5;
        break

    };
    return {
        extraTop,
        extraLeft,
        timer
    };
};


// WEBPACK FOOTER //
// ./src/components/Focus/utils-to-devices/utils-tv-default.ts